import React, { ReactNode, FC, useContext, HTMLAttributes } from 'react';
import { TypeStatics } from 'ia-react-core/~/interfaces/TypeStatic';

import TableContext from '../_TableContext';
import TableHeadContext from '../_TableHeadContext';
import { StyledHeader } from './TableHeader.styles';

export interface TableHeaderProps extends HTMLAttributes<HTMLDivElement> {
  /** Alignment of the column. */
  textAlign?: string;
  children?: ReactNode;
  isColumn?: boolean;
  /** Flex value of the column. */
  flex?: number;
  /** Width of the column. */
  width?: number | string;
  /** Padding of the cell. */
  padding?: number | string;
  /** Text color of the header. */
  color?: string;
  debug?: boolean;
  colIndex?: number;
  /** @ignore */
  scope?: string[];
  /** @ignore */
  data?: unknown;
  /** @ignore */
  display?: string;
}

export interface TableHeaderStatics extends TypeStatics {
  Styled: typeof StyledHeader;
}

const TableHeaderDefaultProps = {
  flex: 1,
};

/**
 * @mode developer
 */
const TableHeader: FC<TableHeaderProps> & TableHeaderStatics = ({ scope, data, ...props }) => {
  const { debug, headPadding, displayMode } = useContext(TableContext);
  const { isHead, textAlign, background } = useContext(TableHeadContext);

  return (
    <StyledHeader
      role={isHead ? 'columnheader' : 'rowheader'}
      textAlign={textAlign}
      debug={debug}
      padding={headPadding}
      displayMode={displayMode}
      background={background}
      {...props}
    />
  );
};

TableHeader.defaultProps = TableHeaderDefaultProps;
TableHeader.type = Symbol('Table.Header');
TableHeader.Styled = StyledHeader;

export default TableHeader;
